import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { EDIT_USER_META_MUTATION } from 'src/graphql/currentUserMeta/mutation';
import client from 'src/utils/api/client';
import CurrentUserMetaReloadContext from 'src/utils/context/CurrentUserMetaReloadContext';
import VisibilitySettingsPopup from './VisibilitySettingsPopup';
import s from './VisibilitySettings.styles';

const VisibilitySettings = ({ name, ...props }) => {
  const [opened, setOpened] = useState(false);
  const currentUserMetaReload = useContext(CurrentUserMetaReloadContext);

  const onSubmit = data => {
    setOpened(false);

    client
      .mutate({
        mutation: EDIT_USER_META_MUTATION,
        variables: {
          key: name,
          value: data.toString(),
        },
      })
      .then(() => {
        currentUserMetaReload();
      });
  };

  return (
    <s.SettingsWrapper>
      <s.SettingsButton onClick={() => setOpened(!opened)}>
        <s.SettingsButtonIcon name="gear" />
      </s.SettingsButton>
      {opened && (
        <VisibilitySettingsPopup
          name={name}
          onClose={() => setOpened(false)}
          onSubmit={onSubmit}
          {...props}
        />
      )}
    </s.SettingsWrapper>
  );
};

VisibilitySettings.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
  meta: PropTypes.string,
  name: PropTypes.string,
};

export default React.memo(VisibilitySettings);
